export function offset(el) {
	if (el === window) {
		return { top: 0, left: 0 };
	}
	let { top, left } = el.getBoundingClientRect();

	return { top, left };
}

export function style(el, property) {
	return window.getComputedStyle(el).getPropertyValue(property);
}

export function viewport() {
	let
		e = window,
		a = 'inner';

	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}

	return {
		width: e[a + 'Width'],
		height: e[a + 'Height']
	};
}


export function height(el) {
	if (el === window) {
		return viewport().height;
	}
	return parseFloat(window.getComputedStyle(el).getPropertyValue('height'), 10);
}

export function width(el) {
	if (el === window) {
		return viewport().width;
	}
	return parseFloat(window.getComputedStyle(el).getPropertyValue('width'), 10);
}

export function css(element, innerCss) {
	let innerStyle = element.style;
	Object.keys(innerCss).forEach(prop => {
		innerStyle[prop] = css[prop];
	});
}

export function ready(fn) {
	if (typeof fn !== 'function') {
		return undefined;
	}

	if (document.readyState === 'complete') {
		return fn();
	}

	document.addEventListener('DOMContentLoaded', fn, false);
	return undefined;
}

export function getScrollTarget(el) {
	return el.closest('.layout-view,.scroll') || window;
}

export function getScrollPosition(scrollTarget) {
	if (scrollTarget === window) {
		return window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
	}
	return scrollTarget.scrollTop;
}

function setScroll(scrollTarget, innerOffset) {
	if (scrollTarget === window) {
		document.documentElement.scrollTop = innerOffset;
		document.body.scrollTop = innerOffset;
		return undefined;
	}
	scrollTarget.scrollTop = innerOffset;
	return undefined;
}

function animScrollTo(el, to, duration) {
	if (duration <= 0) {
		return;
	}

	const pos = getScrollPosition(el);

	requestAnimationFrame(() => {
		setScroll(el, pos + (to - pos) / duration * 16);
		if (el.scrollTop !== to) {
			animScrollTo(el, to, duration - 16);
		}
	});
}


export function setScrollPosition(scrollTarget, innerOffset, duration) {
	if (duration) {
		animScrollTo(scrollTarget, innerOffset, duration);
		return;
	}
	setScroll(scrollTarget, innerOffset);
}

const prefix = ['-webkit-', '-moz-', '-ms-', '-o-'];
export function cssTransform(val) {
	let o = { transform: val };
	prefix.forEach(p => {
		o[p + 'transform'] = val;
	});
	return o;
}
